(function () {
  'use strict';

  function initMobileMenuFocusGuard() {
    var menu = document.getElementById('MobileMenu');
    if (!menu || menu.dataset.focusGuardBound === '2') return;
    var contact = menu.querySelector('a[href="/pages/contact"],a[href$="/pages/contact"]');
    if (contact && contact.closest('details:not([open])')) menu.appendChild(contact);
    menu.dataset.focusGuardBound = '2';
    var direction = 1;
    var redirecting = false;
    var isOpen = function () {
      return menu.classList.contains('is-open');
    };
    var focusable = function () {
      return Array.prototype.slice.call(menu.querySelectorAll(
        'a[href],button:not([disabled]),summary,input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
      )).filter(function (element) { return element.getClientRects().length > 0; });
    };
    var focusMenu = function (toEnd) {
      var targets = focusable();
      var target = toEnd ? targets[targets.length - 1] : targets[0];
      if (target) {
        try { target.focus({ preventScroll: true }); }
        catch (error) { target.focus(); }
      } else {
        menu.setAttribute('tabindex', '-1');
        menu.focus();
      }
    };
    var redirect = function (toEnd) {
      if (redirecting) return;
      redirecting = true;
      focusMenu(toEnd);
      Promise.resolve().then(function () {
        if (isOpen() && !menu.contains(document.activeElement)) focusMenu(toEnd);
      });
      window.setTimeout(function () {
        if (isOpen() && !menu.contains(document.activeElement)) focusMenu(toEnd);
        redirecting = false;
      }, 0);
    };
    window.addEventListener('keydown', function (event) {
      var isTabKey = event.key === 'Tab' || event.code === 'Tab' || event.keyCode === 9 || event.which === 9;
      if (!isOpen() || !isTabKey) return;
      direction = event.shiftKey ? -1 : 1;
      var targets = focusable();
      if (!targets.length) {
        event.preventDefault();
        redirect(false);
        event.stopImmediatePropagation();
        return;
      }
      var active = document.activeElement;
      var first = targets[0];
      var last = targets[targets.length - 1];
      var outside = !menu.contains(active);
      if ((event.shiftKey && (active === first || outside)) || (!event.shiftKey && (active === last || outside))) {
        event.preventDefault();
        redirect(event.shiftKey);
        event.stopImmediatePropagation();
      }
    }, true);
    menu.addEventListener('focusout', function (event) {
      if (!isOpen()) return;
      var targets = focusable();
      if (!targets.length) return;
      var first = targets[0];
      var last = targets[targets.length - 1];
      if ((event.target !== first && event.target !== last) || targets.indexOf(event.relatedTarget) !== -1) return;
      var toEnd = event.target === first;
      direction = toEnd ? -1 : 1;
      focusMenu(toEnd);
      Promise.resolve().then(function () {
        if (isOpen() && focusable().indexOf(document.activeElement) === -1) focusMenu(toEnd);
      });
      window.setTimeout(function () {
        if (isOpen() && focusable().indexOf(document.activeElement) === -1) focusMenu(toEnd);
      }, 0);
    }, true);
    document.addEventListener('focusin', function (event) {
      if (!isOpen() || menu.contains(event.target)) return;
      redirect(direction < 0);
    }, true);
  }

  function initSearch(root) {
    var scope = root || document;
    var dialog = document.querySelector('[data-header-search]');
    if (!dialog) return;
    scope.querySelectorAll('[data-search-open]').forEach(function (button) {
      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';
      button.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        window.setTimeout(function () {
          var input = dialog.querySelector('[data-search-input]');
          if (input) input.focus();
        }, 30);
      });
    });
    dialog.querySelectorAll('[data-search-close]').forEach(function (button) {
      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';
      button.addEventListener('click', function () { dialog.close(); });
    });
    if (dialog.dataset.bound !== '1') {
      dialog.dataset.bound = '1';
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }
  }

  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
      if (carousel.dataset.bound === '1') return;
      carousel.dataset.bound = '1';
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      var step = function () {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 16 : 320;
      };
      carousel.querySelectorAll('[data-carousel-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      });
      carousel.querySelectorAll('[data-carousel-next]').forEach(function (btn) {
        btn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      });
    });
  }

  function initCollection(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-filter-input]').forEach(function (input) {
      if (input.dataset.bound === '1') return;
      input.dataset.bound = '1';
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
    scope.querySelectorAll('[data-collection-sort]').forEach(function (select) {
      if (select.dataset.bound === '1') return;
      select.dataset.bound = '1';
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initVariantPicker(productRoot) {
    var picker = productRoot.querySelector('[data-soniel-picker]');
    if (!picker || picker.dataset.bound === '1') return;
    picker.dataset.bound = '1';
    var select = picker.querySelector('[data-product-variant]');
    if (!select) return;
    var fieldsets = picker.querySelectorAll('fieldset');
    var addBtn = productRoot.querySelector('[data-primary-add]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');

    function selectedValues() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var active = fs.querySelector('[data-option-btn].is-active');
        return active ? active.getAttribute('data-value') : '';
      });
    }

    function findOption(values) {
      var match = null;
      Array.prototype.forEach.call(select.options, function (opt) {
        var parts = (opt.getAttribute('data-options') || '').split('|||');
        var ok = values.every(function (val, i) { return !val || parts[i] === val; });
        if (ok && !match) match = opt;
      });
      return match;
    }

    function apply() {
      var values = selectedValues();
      var opt = findOption(values);
      if (!opt) return;
      select.value = opt.value;
      var available = opt.getAttribute('data-available') !== 'false';
      if (addBtn) {
        addBtn.disabled = !available;
        /* 2026-11-03 : taille épuisée sélectionnée → libellé "Épuisé" */
        var so = addBtn.getAttribute('data-soniel-soldout');
        if (so) {
          if (!available) { if (!addBtn.dataset.sonielLabel) addBtn.dataset.sonielLabel = addBtn.textContent.trim(); addBtn.textContent = so; addBtn.dataset.sonielSoFlag = '1'; }
          else if (addBtn.dataset.sonielSoFlag === '1') { addBtn.dataset.sonielSoFlag = ''; addBtn.textContent = addBtn.dataset.sonielLabel || addBtn.textContent; }
        }
      }
      if (stickyVariant) stickyVariant.textContent = opt.getAttribute('data-title') || '';
      fieldsets.forEach(function (fs, idx) {
        var label = fs.querySelector('[data-option-label]');
        var active = fs.querySelector('[data-option-btn].is-active');
        if (label && active) label.textContent = active.getAttribute('data-value');
        fs.querySelectorAll('[data-option-btn]').forEach(function (btn) {
          var trial = values.slice();
          trial[idx] = btn.getAttribute('data-value');
          // 2026-11-01: disponible si AU MOINS une variante disponible correspond (pas seulement la 1re)
          var on = Array.prototype.some.call(select.options, function (o) {
            var p = (o.getAttribute('data-options') || '').split('|||');
            return o.getAttribute('data-available') !== 'false' && trial.every(function (val, i) { return !val || p[i] === val; });
          });
          btn.classList.toggle('is-unavailable', !on);
        });
      });
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    picker.querySelectorAll('[data-option-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fs = btn.closest('fieldset');
        fs.querySelectorAll('[data-option-btn]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        apply();
      });
    });
    apply();
  }

  function initProduct(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-product-root]').forEach(function (productRoot) {
      if (productRoot.dataset.bound === '1') return;
      productRoot.dataset.bound = '1';
      var mainImage = productRoot.querySelector('[data-gallery-main]');
      var zoomDialog = document.querySelector('[data-product-zoom]');
      var zoomImage = zoomDialog && zoomDialog.querySelector('[data-zoom-image]');
      var activeZoomSrc = mainImage ? mainImage.src : '';

      productRoot.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!mainImage) return;
          mainImage.src = thumb.dataset.fullSrc || mainImage.src;
          mainImage.removeAttribute('srcset');
          mainImage.alt = thumb.dataset.alt || mainImage.alt;
          activeZoomSrc = thumb.dataset.zoomSrc || thumb.dataset.fullSrc || mainImage.src;
          productRoot.querySelectorAll('[data-gallery-thumb]').forEach(function (item) {
            var active = item === thumb;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      var zoomOpen = productRoot.querySelector('[data-gallery-zoom-open]');
      if (zoomOpen && zoomDialog && zoomImage) {
        zoomOpen.addEventListener('click', function () {
          zoomImage.src = activeZoomSrc || mainImage.src;
          zoomImage.alt = mainImage ? mainImage.alt : '';
          if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
          else zoomDialog.setAttribute('open', '');
        });
      }
      if (zoomDialog && zoomDialog.dataset.bound !== '1') {
        zoomDialog.dataset.bound = '1';
        var close = zoomDialog.querySelector('[data-zoom-close]');
        if (close) close.addEventListener('click', function () { zoomDialog.close(); });
        zoomDialog.addEventListener('click', function (event) { if (event.target === zoomDialog) zoomDialog.close(); });
      }

      initVariantPicker(productRoot);

      var galleryVariantSelect = productRoot.querySelector('[data-product-variant]');
      var syncVariantGallery = function () {
        if (!mainImage || !galleryVariantSelect) return;
        var selected = galleryVariantSelect.options[galleryVariantSelect.selectedIndex];
        var src = selected && selected.getAttribute('data-image');
        if (!src) return;
        var selectedThumb = null;
        productRoot.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          var full = thumb.getAttribute('data-full-src') || '';
          var active = full && src.indexOf(full.split('?')[0].split('/').pop()) !== -1;
          if (active && !selectedThumb) selectedThumb = thumb;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        mainImage.src = src;
        mainImage.removeAttribute('srcset');
        if (selectedThumb) {
          mainImage.alt = selectedThumb.dataset.alt || mainImage.alt;
          activeZoomSrc = selectedThumb.dataset.zoomSrc || selectedThumb.dataset.fullSrc || src;
        }
        if (zoomImage) zoomImage.alt = mainImage.alt;
      };
      if (galleryVariantSelect) {
        galleryVariantSelect.addEventListener('change', syncVariantGallery);
        syncVariantGallery();
      }

      var form = productRoot.querySelector('form[action*="/cart/add"]');
      var sourceButton = productRoot.querySelector('[data-primary-add]');
      var sticky = document.querySelector('[data-v2-sticky-atc]');
      var stickyButton = sticky && sticky.querySelector('[data-sticky-add]');
      var variantSelect = productRoot.querySelector('[data-product-variant]');
      var stickyVariant = sticky && sticky.querySelector('[data-sticky-variant]');
      if (form && sourceButton && sticky && stickyButton) {
        var setVisible = function (visible) {
          sticky.hidden = !visible;
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        };
        var placeSticky = function () {
          var cookie = document.querySelector('.sn-cookie:not([hidden])');
          var lift = 0;
          if (cookie) {
            var crect = cookie.getBoundingClientRect();
            if (crect.height > 20 && crect.bottom > window.innerHeight - 12) lift = Math.round(crect.height + 16);
          }
          sticky.style.bottom = lift ? (lift + 'px') : '0px';
        };
        var updateSticky = function () {
          var rect = sourceButton.getBoundingClientRect();
          var out = rect.bottom < 80 || rect.top > window.innerHeight - 12;
          setVisible(out);
          placeSticky();
        };
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(updateSticky, { threshold: [0, 0.2, 1] });
          observer.observe(sourceButton);
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();
        stickyButton.addEventListener('click', function () {
          if (sourceButton.dataset.sonielSizeLock === '1') { var pk = productRoot.querySelector('.soniel-size, [data-option-btn]'); if (pk) pk.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (!sourceButton.disabled) sourceButton.click();
        });
        var sync = function () {
          /* 2026-11-03 : la barre fixe reflète l'état réel du bouton principal (libellé + verrou taille) */
          var locked = sourceButton.dataset.sonielSizeLock === '1';
          stickyButton.disabled = sourceButton.disabled && !locked;
          stickyButton.textContent = sourceButton.textContent.trim();
          stickyButton.classList.toggle('is-size-lock', locked);
          if (variantSelect && stickyVariant) {
            var selected = variantSelect.options[variantSelect.selectedIndex];
            if (selected) {
              stickyVariant.textContent = (selected.getAttribute('data-title') || selected.textContent).split('—')[0].trim();
              var priceEl = sticky.querySelector('[data-sticky-price]');
              var price = selected.getAttribute('data-price');
              if (priceEl && price) priceEl.textContent = price;
            }
          }
        };
        if (variantSelect) variantSelect.addEventListener('change', function(){ setTimeout(sync, 0); });
        if ('MutationObserver' in window) new MutationObserver(function(){ sync(); }).observe(sourceButton, { attributes: true, attributeFilter: ['disabled','data-soniel-size-lock'], childList: true, characterData: true, subtree: true });
        document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-option-btn]')) setTimeout(sync, 10); });
        sync();
      }

      var sellingPlanWrap = productRoot.querySelector('[id^="sp-wrap-"]');
      if (sellingPlanWrap) {
        var hidden = sellingPlanWrap.querySelector('input[name="selling_plan"]');
        sellingPlanWrap.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
          radio.addEventListener('change', function () { if (hidden) hidden.value = radio.dataset.sp || ''; });
        });
      }
    });
  }

  function init(root) {
    initMobileMenuFocusGuard();
    initSearch(root);
    initCarousels(root);
    initCollection(root);
    initProduct(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target || document); });
})();
